import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicUser } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getUser = async (userId: string): Promise<PublicUser> => {
  const response = await axiosClient.get(`/users/${userId}`);
  return response.data;
};

export function getUserQueryKey({ userId }: { userId: string }) {
  return ["user", userId];
}

export function useGetUser(
  userId: string,
  queryOptions?: Partial<UseQueryOptions<PublicUser, HttpError>>,
) {
  return useQuery({
    queryKey: getUserQueryKey({ userId }),
    queryFn: () => getUser(userId),
    ...queryOptions,
  });
}
